app.controller('AvailabilityCtrl', function($scope) {
	
});